import React, {FC} from 'react'
import {KTSVG} from '../../../_metronic/helpers'

type Props = {
    icon: string
    title: string
    description: string
}
const PageHeader: FC<Props> = ({icon, description, title}) => {

    return (
        <>
            <div className="card">
                <div id="kt_page_header_details" className="collapse show">
                    <div className="card-body">
                        <div className="d-flex flex-wrap flex-sm-nowrap">
                            <div
                                className="d-flex flex-center flex-shrink-0 bg-light rounded w-100px h-100px me-7">
                                <KTSVG path={icon}
                                       className={`svg-icon svg-icon-4hx fill-primary`}
                                />
                            </div>
                            <div className="d-flex flex-column">
                                <div className="d-flex align-items-center mb-1">
                                    <span className="text-gray-800 fs-2 fw-bolder me-3">{title}</span>
                                </div>
                                <span className="d-flex flex-wrap fw-bold mb-4 fs-6 text-gray-500">{description}</span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export {PageHeader}